import { render, staticRenderFns } from "./CannedMessageSelector.vue?vue&type=template&id=656e1c78&scoped=true"
import script from "./CannedMessageSelector.vue?vue&type=script&lang=js"
export * from "./CannedMessageSelector.vue?vue&type=script&lang=js"
import style0 from "./CannedMessageSelector.vue?vue&type=style&index=0&id=656e1c78&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "656e1c78",
  null
  
)

export default component.exports